const EventType = Object.freeze({
  EVENT_WITHOUT_REGISTRATION: 'EVENT_WITHOUT_REGISTRATION',
  EVENT_WITH_MY_KWS_REGISTRATION: 'EVENT_WITH_MY_KWS_REGISTRATION',
  EVENT_WITH_REGISTRATION: 'EVENT_WITH_REGISTRATION',
});

export default EventType;
